

const apiUrl = "https://connect.lupa.co.il/";



export const login_request_url = `${apiUrl}V2/api/entry.aspx?method=login&callback=iframe&view=gui`;
export const login_facebook_request_url = `${apiUrl}V2/api/entry.aspx?method=signupexternal&platform=facebook&callback=https://account.lupa.co.il/track_orders.aspx`;//firdt,last,email
export const login_google_request_url = `${apiUrl}V2/api/entry.aspx?method=signupexternal&platform=google&callback=https://account.lupa.co.il/track_orders.aspx`;
export const signup_request_url = `${apiUrl}V2/api/entry.aspx?method=signup&callback=iframe&view=gui`;
export const reminder_request_url = `${apiUrl}V2/api/entry.aspx?method=reminder&view=gui`;
export const get_user_by_email_request_url = `${apiUrl}V2/api/entry.aspx?method=getuserbyemail&view=gui`;
export const renewpassword_request_url = `${apiUrl}V2/api/entry.aspx?method=renewpassword&view=gui`;
export const activation_request_url = `${apiUrl}V2/api/entry.aspx?method=activation`;
